// Action Types

export const Types = {
  GET_MONTH_BALANCE_REQUESTED: 'humanResources/GET_MONTH_BALANCE_REQUESTED',
  GET_MONTH_BALANCE_SUCCEEDED: 'humanResources/GET_MONTH_BALANCE_SUCCEEDED',
  GET_MONTH_BALANCE_FAILED: 'humanResources/GET_MONTH_BALANCE_FAILED',

  GET_HOURS_BANK_REQUESTED: 'humanResources/GET_HOURS_BANK_REQUESTED',
  GET_HOURS_BANK_SUCCEEDED: 'humanResources/GET_HOURS_BANK_SUCCEEDED',
  GET_HOURS_BANK_FAILED: 'humanResources/GET_HOURS_BANK_FAILED',

  GET_EXPEDIENT_STATUS_REQUESTED: 'humanResources/GET_EXPEDIENT_STATUS_REQUESTED',
  GET_EXPEDIENT_STATUS_SUCCEEDED: 'humanResources/GET_EXPEDIENT_STATUS_SUCCEEDED',
  GET_EXPEDIENT_STATUS_FAILED: 'humanResources/GET_EXPEDIENT_STATUS_FAILED',

  GET_LAST_EXPEDIENT_INPUT_REQUESTED: 'humanResources/GET_LAST_EXPEDIENT_INPUT_REQUESTED',
  GET_LAST_EXPEDIENT_INPUT_SUCCEEDED: 'humanResources/GET_LAST_EXPEDIENT_INPUT_SUCCEEDED',
  GET_LAST_EXPEDIENT_INPUT_FAILED: 'humanResources/GET_LAST_EXPEDIENT_INPUT_FAILED',

  GET_LAST_EXPEDIENT_OUTPUT_REQUESTED: 'humanResources/GET_LAST_EXPEDIENT_OUTPUT_REQUESTED',
  GET_LAST_EXPEDIENT_OUTPUT_SUCCEEDED: 'humanResources/GET_LAST_EXPEDIENT_OUTPUT_SUCCEEDED',
  GET_LAST_EXPEDIENT_OUTPUT_FAILED: 'humanResources/GET_LAST_EXPEDIENT_OUTPUT_FAILED',

  GET_MONTHLY_WORKLOAD_REQUESTED: 'humanResources/GET_MONTHLY_WORKLOAD_REQUESTED',
  GET_MONTHLY_WORKLOAD_SUCCEEDED: 'humanResources/GET_MONTHLY_WORKLOAD_SUCCEEDED',
  GET_MONTHLY_WORKLOAD_FAILED: 'humanResources/GET_MONTHLY_WORKLOAD_FAILED',

  GET_MONTHLY_ACTIVITIES_REQUESTED: 'humanResources/GET_MONTHLY_ACTIVITIES_REQUESTED',
  GET_MONTHLY_ACTIVITIES_SUCCEEDED: 'humanResources/GET_MONTHLY_ACTIVITIES_SUCCEEDED',
  GET_MONTHLY_ACTIVITIES_FAILED: 'humanResources/GET_MONTHLY_ACTIVITIES_FAILED',

  GET_PROJECTS_REQUESTED: 'humanResources/GET_PROJECTS_REQUESTED',
  GET_PROJECTS_SUCCEEDED: 'humanResources/GET_PROJECTS_SUCCEEDED',
  GET_PROJECTS_FAILED: 'humanResources/GET_PROJECTS_FAILED',

  GET_ACTIVITIES_REQUESTED: 'humanResources/GET_ACTIVITIES_REQUESTED',
  GET_ACTIVITIES_SUCCEEDED: 'humanResources/GET_ACTIVITIES_SUCCEEDED',
  GET_ACTIVITIES_FAILED: 'humanResources/GET_ACTIVITIES_FAILED',

  START_EXPEDIENT_REQUESTED: 'humanResources/START_EXPEDIENT_REQUESTED',
  START_EXPEDIENT_SUCCEEDED: 'humanResources/START_EXPEDIENT_SUCCEEDED',
  START_EXPEDIENT_FAILED: 'humanResources/START_EXPEDIENT_FAILED',

  FINISH_EXPEDIENT_REQUESTED: 'humanResources/FINISH_EXPEDIENT_REQUESTED',
  FINISH_EXPEDIENT_SUCCEEDED: 'humanResources/FINISH_EXPEDIENT_SUCCEEDED',
  FINISH_EXPEDIENT_FAILED: 'humanResources/FINISH_EXPEDIENT_FAILED',

  CHECK_RETROACTIVE_REQUESTED: 'humanResources/CHECK_RETROACTIVE_REQUESTED',
  CHECK_RETROACTIVE_SUCCEEDED: 'humanResources/CHECK_RETROACTIVE_SUCCEEDED',
  CHECK_RETROACTIVE_FAILED: 'humanResources/CHECK_RETROACTIVE_FAILED',

  GET_MONTHLY_ACTIVITIES_REPORT_REQUESTED: 'humanResources/GET_MONTHLY_ACTIVITIES_REPORT_REQUESTED',
  GET_MONTHLY_ACTIVITIES_REPORT_SUCCEEDED: 'humanResources/GET_MONTHLY_ACTIVITIES_REPORT_SUCCEEDED',
  GET_MONTHLY_ACTIVITIES_REPORT_FAILED: 'humanResources/GET_MONTHLY_ACTIVITIES_REPORT_FAILED',

  REGISTER_ABSENCE_REQUESTED: 'humanResources/REGISTER_ABSENCE_REQUESTED',
  REGISTER_ABSENCE_SUCCEEDED: 'humanResources/REGISTER_ABSENCE_SUCCEEDED',
  REGISTER_ABSENCE_FAILED: 'humanResources/REGISTER_ABSENCE_FAILED',

  REGISTER_VACATION_REQUESTED: 'humanResources/REGISTER_VACATION_REQUESTED',
  REGISTER_VACATION_SUCCEEDED: 'humanResources/REGISTER_VACATION_SUCCEEDED',
  REGISTER_VACATION_FAILED: 'humanResources/REGISTER_VACATION_FAILED',

  GET_PENDING_SOLICITATIONS_REQUESTED: 'humanResources/GET_PENDING_SOLICITATIONS_REQUESTED',
  GET_PENDING_SOLICITATIONS_SUCCEEDED: 'humanResources/GET_PENDING_SOLICITATIONS_SUCCEEDED',
  GET_PENDING_SOLICITATIONS_FAILED: 'humanResources/GET_PENDING_SOLICITATIONS_FAILED',

  DELETE_PENDING_SOLICITATION_REQUESTED: 'humanResources/DELETE_PENDING_SOLICITATION_REQUESTED',
  DELETE_PENDING_SOLICITATION_SUCCEEDED: 'humanResources/DELETE_PENDING_SOLICITATION_SUCCEEDED',
  DELETE_PENDING_SOLICITATION_FAILED: 'humanResources/DELETE_PENDING_SOLICITATION_FAILED',

  UPDATE_SOLICITATION_REQUESTED: 'humanResources/UPDATE_SOLICITATION_REQUESTED',
  UPDATE_SOLICITATION_SUCCEEDED: 'humanResources/UPDATE_SOLICITATION_SUCCEEDED',
  UPDATE_SOLICITATION_FAILED: 'humanResources/UPDATE_SOLICITATION_FAILED',

  GET_RH_DASHBOARD_REQUESTED: 'humanResources/GET_RH_DASHBOARD_REQUESTED',
  GET_RH_DASHBOARD_SUCCEEDED: 'humanResources/GET_RH_DASHBOARD_SUCCEEDED',
  GET_RH_DASHBOARD_FAILED: 'humanResources/GET_RH_DASHBOARD_FAILED',
}

// Action Creators

export function getMonthBalance() {
  return {
    type: Types.GET_MONTH_BALANCE_REQUESTED,
  }
}

export function getHoursBank(userId) {
  return {
    type: Types.GET_HOURS_BANK_REQUESTED,
    payload: userId,
  }
}

export function getExpedientStatus() {
  return {
    type: Types.GET_EXPEDIENT_STATUS_REQUESTED,
  }
}

export function getLastExpedientInput() {
  return {
    type: Types.GET_LAST_EXPEDIENT_INPUT_REQUESTED,
  }
}

export function getLastExpedientOutput() {
  return {
    type: Types.GET_LAST_EXPEDIENT_OUTPUT_REQUESTED,
  }
}

export function getMonthlyWorkload(userId) {
  return {
    type: Types.GET_MONTHLY_WORKLOAD_REQUESTED,
    payload: userId,
  }
}

export function getMonthlyActivities() {
  return {
    type: Types.GET_MONTHLY_ACTIVITIES_REQUESTED,
  }
}

export function getProjects() {
  return {
    type: Types.GET_PROJECTS_REQUESTED,
  }
}

export function getActivities(projectId) {
  return {
    type: Types.GET_ACTIVITIES_REQUESTED,
    payload: {
      projectId,
    },
  }
}

export function startExpedient() {
  return {
    type: Types.START_EXPEDIENT_REQUESTED,
  }
}

export function finishExpedient(data) {
  return {
    type: Types.FINISH_EXPEDIENT_REQUESTED,
    payload: {
      data,
    },
  }
}

export function checkRetroactive(data) {
  return {
    type: Types.CHECK_RETROACTIVE_REQUESTED,
    payload: {
      data,
    },
  }
}

export function getMonthlyActivitiesReport(month, userId) {
  return {
    type: Types.GET_MONTHLY_ACTIVITIES_REPORT_REQUESTED,
    payload: { month, userId },
  }
}

export function registerAbsence(data) {
  return {
    type: Types.REGISTER_ABSENCE_REQUESTED,
    payload: {
      data,
    },
  }
}

export function registerVacation(data) {
  return {
    type: Types.REGISTER_VACATION_REQUESTED,
    payload: {
      data,
    },
  }
}

export function getPendingSolicitations(isManager) {
  return {
    type: Types.GET_PENDING_SOLICITATIONS_REQUESTED,
    payload: {
      isManager,
    },
  }
}

export function deletePendingSolicitation(id, tab) {
  return {
    type: Types.DELETE_PENDING_SOLICITATION_REQUESTED,
    payload: {
      pend_id: id,
      pend_tab: tab,
    },
  }
}

export function updateSolicitation(payload) {
  return {
    type: Types.UPDATE_SOLICITATION_REQUESTED,
    payload,
  }
}

export function getRhDashboard(mes) {
  return {
    type: Types.GET_RH_DASHBOARD_REQUESTED,
    payload: { mes },
  }
}

// Reducer

const INITIAL_STATE = {
  getMonthBalanceIsLoading: false,
  getMonthBalanceError: null,
  monthBalance: null,

  getHoursBankIsLoading: false,
  getHoursBankError: null,
  hoursBank: null,

  getExpedientStatusIsLoading: false,
  getExpedientStatusError: null,
  expedientStatus: null,

  getLastExpedientInputIsLoading: false,
  getLastExpedientInputError: null,
  lastExpedientInput: null,

  getLastExpedientOutputIsLoading: false,
  getLastExpedientOutputError: null,
  lastExpedientOutput: null,

  getMonthlyWorkloadIsLoading: false,
  getMonthlyWorkloadError: null,
  monthlyWorkload: null,

  getMonthlyActivitiesIsLoading: false,
  getMonthlyActivitiesError: null,
  monthlyActivities: null,

  getProjectsIsLoading: false,
  getProjectsError: null,
  projects: null,

  getActivitiesIsLoading: false,
  getActivitiesError: null,
  activities: null,

  startExpedientIsLoading: false,
  startExpedientError: null,

  finishExpedientIsLoading: false,
  finishExpedientError: null,

  checkRetroactiveIsLoading: false,
  checkRetroactiveError: null,
  checkRetroactiveResult: null,

  getMonthlyActivitiesReportIsLoading: false,
  getMonthlyActivitiesReportError: null,
  monthlyActivitiesReport: null,

  registerAbsenceIsLoading: false,
  registerAbsenceError: null,

  registerVacationIsLoading: false,
  registerVacationError: null,

  getPendingSolicitationsIsLoading: false,
  getPendingSolicitationsError: null,
  pendingSolicitations: null,

  updateSolicitationIsLoading: false,
  updateSolicitationError: null,

  deletePendingSolicitationIsLoading: false,

  getRhDashboardIsLoading: false,
  getRhDashboardError: null,
  rhDashboard: null,
}

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_MONTH_BALANCE_REQUESTED:
      return {
        ...state,
        getMonthBalanceIsLoading: true,
      }
    case Types.GET_MONTH_BALANCE_SUCCEEDED:
      return {
        ...state,
        getMonthBalanceIsLoading: false,
        getMonthBalanceError: null,
        monthBalance: action.payload,
      }
    case Types.GET_MONTH_BALANCE_FAILED:
      return {
        ...state,
        getMonthBalanceIsLoading: false,
        getMonthBalanceError: action.payload,
        monthBalance: null,
      }

    case Types.GET_HOURS_BANK_REQUESTED:
      return {
        ...state,
        getHoursBankIsLoading: true,
      }
    case Types.GET_HOURS_BANK_SUCCEEDED:
      return {
        ...state,
        getHoursBankIsLoading: false,
        getHoursBankError: null,
        hoursBank: action.payload,
      }
    case Types.GET_HOURS_BANK_FAILED:
      return {
        ...state,
        getHoursBankIsLoading: false,
        getHoursBankError: action.payload,
        hoursBank: null,
      }

    case Types.GET_EXPEDIENT_STATUS_REQUESTED:
      return {
        ...state,
        getExpedientStatusIsLoading: true,
      }
    case Types.GET_EXPEDIENT_STATUS_SUCCEEDED:
      return {
        ...state,
        getExpedientStatusIsLoading: false,
        getExpedientStatusError: null,
        expedientStatus: action.payload,
      }
    case Types.GET_EXPEDIENT_STATUS_FAILED:
      return {
        ...state,
        getExpedientStatusIsLoading: false,
        getExpedientStatusError: action.payload,
        expedientStatus: null,
      }

    case Types.GET_LAST_EXPEDIENT_INPUT_REQUESTED:
      return {
        ...state,
        getLastExpedientInputIsLoading: true,
      }
    case Types.GET_LAST_EXPEDIENT_INPUT_SUCCEEDED:
      return {
        ...state,
        getLastExpedientInputIsLoading: false,
        getLastExpedientInputError: null,
        lastExpedientInput: action.payload,
      }
    case Types.GET_LAST_EXPEDIENT_INPUT_FAILED:
      return {
        ...state,
        getLastExpedientInputIsLoading: false,
        getLastExpedientInputError: action.payload,
        lastExpedientInput: null,
      }

    case Types.GET_LAST_EXPEDIENT_OUTPUT_REQUESTED:
      return {
        ...state,
        getLastExpedientOutputIsLoading: true,
      }

    case Types.GET_LAST_EXPEDIENT_OUTPUT_SUCCEEDED:
      return {
        ...state,
        getLastExpedientOutputIsLoading: false,
        getLastExpedientOutputError: null,
        lastExpedientOutput: action.payload,
      }
    case Types.GET_LAST_EXPEDIENT_OUTPUT_FAILED:
      return {
        ...state,
        getLastExpedientOutputIsLoading: false,
        getLastExpedientOutputError: action.payload,
        lastExpedientOutput: null,
      }

    case Types.GET_MONTHLY_WORKLOAD_REQUESTED:
      return {
        ...state,
        getMonthlyWorkloadIsLoading: true,
      }
    case Types.GET_MONTHLY_WORKLOAD_SUCCEEDED:
      return {
        ...state,
        getMonthlyWorkloadIsLoading: false,
        getMonthlyWorkloadError: null,
        monthlyWorkload: action.payload,
      }
    case Types.GET_MONTHLY_WORKLOAD_FAILED:
      return {
        ...state,
        getMonthlyWorkloadIsLoading: false,
        getMonthlyWorkloadError: action.payload,
        monthlyWorkload: null,
      }

    case Types.GET_MONTHLY_ACTIVITIES_REQUESTED:
      return {
        ...state,
        getMonthlyActivitiesIsLoading: true,
      }
    case Types.GET_MONTHLY_ACTIVITIES_SUCCEEDED:
      return {
        ...state,
        getMonthlyActivitiesIsLoading: false,
        getMonthlyActivitiesError: null,
        monthlyActivities: action.payload,
      }
    case Types.GET_MONTHLY_ACTIVITIES_FAILED:
      return {
        ...state,
        getMonthlyActivitiesIsLoading: false,
        getMonthlyActivitiesError: action.payload,
        monthlyActivities: null,
      }

    case Types.GET_PROJECTS_REQUESTED:
      return {
        ...state,
        getProjectsIsLoading: true,
      }
    case Types.GET_PROJECTS_SUCCEEDED:
      return {
        ...state,
        getProjectsIsLoading: false,
        getProjectsError: null,
        projects: action.payload,
      }
    case Types.GET_PROJECTS_FAILED:
      return {
        ...state,
        getProjectsIsLoading: false,
        getProjectsError: action.payload,
        projects: null,
      }

    case Types.GET_ACTIVITIES_REQUESTED:
      return {
        ...state,
        getActivitiesIsLoading: true,
      }
    case Types.GET_ACTIVITIES_SUCCEEDED:
      return {
        ...state,
        getActivitiesIsLoading: false,
        getActivitiesError: null,
        activities: action.payload,
      }
    case Types.GET_ACTIVITIES_FAILED:
      return {
        ...state,
        getActivitiesIsLoading: false,
        getActivitiesError: action.payload,
        activities: null,
      }

    case Types.START_EXPEDIENT_REQUESTED:
      return {
        ...state,
        startExpedientIsLoading: true,
      }
    case Types.START_EXPEDIENT_SUCCEEDED:
      return {
        ...state,
        startExpedientIsLoading: false,
        startExpedientError: null,
        lastExpedientInput: action.payload,
        expedientStatus: false,
      }
    case Types.START_EXPEDIENT_FAILED:
      return {
        ...state,
        startExpedientIsLoading: false,
        startExpedientError: action.payload,
      }

    case Types.FINISH_EXPEDIENT_REQUESTED:
      return {
        ...state,
        finishExpedientIsLoading: true,
      }
    case Types.FINISH_EXPEDIENT_SUCCEEDED:
      return {
        ...state,
        finishExpedientIsLoading: false,
        finishExpedientError: null,
        expedientStatus: true,
      }
    case Types.FINISH_EXPEDIENT_FAILED:
      return {
        ...state,
        finishExpedientIsLoading: false,
        finishExpedientError: action.payload,
      }

    case Types.CHECK_RETROACTIVE_REQUESTED:
      return {
        ...state,
        checkRetroactiveIsLoading: true,
        checkRetroactiveError: null,
        checkRetroactiveResult: null,
      }
    case Types.CHECK_RETROACTIVE_SUCCEEDED:
      return {
        ...state,
        checkRetroactiveIsLoading: false,
        checkRetroactiveError: null,
        checkRetroactiveResult: action.payload,
      }
    case Types.CHECK_RETROACTIVE_FAILED:
      return {
        ...state,
        checkRetroactiveIsLoading: false,
        checkRetroactiveError: action.payload,
        checkRetroactiveResult: null,
      }

    case Types.GET_MONTHLY_ACTIVITIES_REPORT_REQUESTED:
      return {
        ...state,
        getMonthlyActivitiesReportIsLoading: true,
      }
    case Types.GET_MONTHLY_ACTIVITIES_REPORT_SUCCEEDED:
      return {
        ...state,
        getMonthlyActivitiesReportIsLoading: false,
        getMonthlyActivitiesReportError: null,
        monthlyActivitiesReport: action.payload,
      }
    case Types.GET_MONTHLY_ACTIVITIES_REPORT_FAILED:
      return {
        ...state,
        getMonthlyActivitiesReportIsLoading: false,
        getMonthlyActivitiesReportError: action.payload,
        monthlyActivitiesReport: null,
      }

    case Types.REGISTER_ABSENCE_REQUESTED:
      return {
        ...state,
        registerAbsenceIsLoading: true,
      }
    case Types.REGISTER_ABSENCE_SUCCEEDED:
      return {
        ...state,
        registerAbsenceIsLoading: false,
        registerAbsenceError: null,
      }
    case Types.REGISTER_ABSENCE_FAILED:
      return {
        ...state,
        registerAbsenceIsLoading: false,
        registerAbsenceError: action.payload,
      }

    case Types.REGISTER_VACATION_REQUESTED:
      return {
        ...state,
        registerVacationIsLoading: true,
      }
    case Types.REGISTER_VACATION_SUCCEEDED:
      return {
        ...state,
        registerVacationIsLoading: false,
        registerVacationError: null,
      }
    case Types.REGISTER_VACATION_FAILED:
      return {
        ...state,
        registerVacationIsLoading: false,
        registerVacationError: action.payload,
      }

    case Types.GET_PENDING_SOLICITATIONS_REQUESTED:
      return {
        ...state,
        getPendingSolicitationsIsLoading: true,
      }
    case Types.GET_PENDING_SOLICITATIONS_SUCCEEDED:
      return {
        ...state,
        getPendingSolicitationsIsLoading: false,
        getPendingSolicitationsError: null,
        pendingSolicitations: action.payload,
      }
    case Types.GET_PENDING_SOLICITATIONS_FAILED:
      return {
        ...state,
        getPendingSolicitationsIsLoading: false,
        getPendingSolicitationsError: action.payload,
      }

    case Types.DELETE_PENDING_SOLICITATION_REQUESTED:
      return {
        ...state,
        deletePendingSolicitationIsLoading: true,
      }
    case Types.DELETE_PENDING_SOLICITATION_SUCCEEDED:
      return {
        ...state,
        deletePendingSolicitationIsLoading: false,
      }
    case Types.DELETE_PENDING_SOLICITATION_FAILED:
      return {
        ...state,
        deletePendingSolicitationIsLoading: false,
      }

    case Types.UPDATE_SOLICITATION_REQUESTED:
      return {
        ...state,
        updateSolicitationIsLoading: true,
      }
    case Types.UPDATE_SOLICITATION_SUCCEEDED:
      return {
        ...state,
        updateSolicitationIsLoading: false,
        updateSolicitationError: null,
      }
    case Types.UPDATE_SOLICITATION_FAILED:
      return {
        ...state,
        updateSolicitationIsLoading: false,
        updateSolicitationError: action.payload,
      }

    case Types.GET_RH_DASHBOARD_REQUESTED:
      return {
        ...state,
        getRhDashboardIsLoading: true,
        getRhDashboardError: null,
      }
    case Types.GET_RH_DASHBOARD_SUCCEEDED:
      return {
        ...state,
        getRhDashboardIsLoading: false,
        getRhDashboardError: null,
        rhDashboard: action.payload,
      }
    case Types.GET_RH_DASHBOARD_FAILED:
      return {
        ...state,
        getRhDashboardIsLoading: false,
        getRhDashboardError: action.payload,
        rhDashboard: null,
      }

    default:
      return state
  }
}
